module.exports = "<gw-buildings-wizard />"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/quoteandbind/cp/views/cp-buildings-locations.html
// module id = 1052
// module chunks = 0